import React, { createContext, useContext } from 'react'
import { useSelector } from 'react-redux'
import { userSlice } from '../../reducers'
import { useLPQ } from '../../hooks/useLPQ'
import UserPreferences from '../user-preferences'

const LPQContext = createContext()

export const useLPQContext = () => {
  const context = useContext(LPQContext)
  if (!context) {
    throw new Error('useLPQContext must be used within a LPQProvider')
  }
  return context
}

/**
 * Provider to manage UserPreferences modal based on 'lpq' URL parameter
 * Works for all authenticated users on any application route
 */
export const LPQProvider = ({ children }) => {
  const profile = useSelector(userSlice.selectors.selectProfile)
  const { shouldOpenLPQ, lpqParam, closeLPQ, openLPQ, isAuthenticated } = useLPQ()

  const contextValue = {
    shouldOpenLPQ,
    lpqParam,
    closeLPQ,
    openLPQ,
    isAuthenticated
  }

  return (
    <LPQContext.Provider value={contextValue}>
      {children}

      {/* UserPreferences Modal rendered globally for all authenticated users */}
      {isAuthenticated && profile && <UserPreferences />}
    </LPQContext.Provider>
  )
}

export default LPQProvider
